<template>
    <span v-if="mensagem.status == 1">
        <b-button variant="primary" @click.stop="lerNaoLer()" class="float-right ml-2">
            <span>
                <i :class="`fa ${iconBtn}`"></i>
                {{ tituloBtn }}
            </span>
        </b-button>
    </span>
</template>

<script>
import MensagensServicos from './MensagensServicos'

export default {
	props: {
		mensagem: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {}
	},

	methods: {
		lerNaoLer() {
			this.$store.dispatch('addRequest')
			MensagensServicos.lerNaoLerMensagem(this.mensagem.mensagemId).then(
				response => {
					if (response) {
						if (response.success) {
							this.$toast.success(
								'Mensagem atualizada com sucesso!',
								'OK',
								this.$toastConfig.success
							)
							this.$emit('obterMensagensEConversasAtualizadas')
							this.$emit('obterMensagemAtualizada')
						} else {
							this.$toast.error(
								'Erro ao atualizar mensagem!!!',
								'ERROR',
								this.$toastConfig.error
							)
						}
					}
					this.$store.dispatch('removeRequest')
				}
			)
		}
	},

	computed: {
		tituloBtn() {
			if (this.mensagem.leituraStatus == 0) {
				return 'Marcar como lida'
			} else {
				return 'Marcar como não lida'
			}
		},

		iconBtn() {
			if (this.mensagem.leituraStatus == 0) {
				return 'fa-check-circle'
			} else {
				return 'fa-times-circle'
			}
		}
	},

	watch: {},

	validations: {}
}
</script>
